import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';
import {
  isBusinessSubscription,
  isCreatorSubscription,
  SUBSCRIPTION_BUSINESS,
  SUBSCRIPTION_CREATOR,
  SUBSCRIPTION_ENTERPRISE,
  SUBSCRIPTION_TRIAL,
} from '../../Subscription/config';

export interface SubscriptionPlan {
  id: number;
  title: string;
  priceMonthly: string;
  priceAnnual: string;
  amountOfUsers: string;
  featuresMonthly: string[];
  featuresAnnual: string[];
  specialText?: string;
  buttonText: string;
  green: boolean;
  showDetails: boolean;
  cancelAnytime: boolean;
}
const CREATOR_CONF: SubscriptionPlan = {
  id: SUBSCRIPTION_CREATOR,
  title: getLocalizationBasedOnLang('Creator', 'Creawdwr'),
  priceMonthly: '€29',
  priceAnnual: '€340',
  amountOfUsers: getLocalizationBasedOnLang(
    'Up to 19 learners',
    'Hyd at 19 o ddysgwyr',
  ),
  featuresMonthly: [
    getLocalizationBasedOnLang(
      '1,000,000 credits per month',
      `1,000,000 o gredydau'r mis`,
    ),
    getLocalizationBasedOnLang(
      'Supports up to 19 learners',
      'Cefnogaeth i hyd at 19 o ddysgwyr',
    ),
    getLocalizationBasedOnLang(
      'LTI 1.3 interoperability',
      'Rhyngweithrededd LTI 1.3',
    ),
    getLocalizationBasedOnLang('SCORM 1.2 support', 'Allforio SCORM 1.2'),
    getLocalizationBasedOnLang(
      'Free to cancel anytime',
      'Free to cancel anytime',
    ),
  ],
  featuresAnnual: [
    getLocalizationBasedOnLang(
      '12,000,000 AI credits per year',
      `12,000,000 o gredydau y flwyddyn`,
    ),
    getLocalizationBasedOnLang(
      'Supports up to 19 learners',
      'Cefnogaeth i hyd at 19 o ddysgwyr',
    ),
    getLocalizationBasedOnLang(
      'LTI 1.3 interoperability',
      'Rhyngweithrededd LTI 1.3',
    ),
    getLocalizationBasedOnLang('SCORM 1.2 support', 'Allforio SCORM 1.2'),
    getLocalizationBasedOnLang(
      'Free to cancel anytime',
      'Free to cancel anytime',
    ),
  ],
  specialText: undefined,
  buttonText: getLocalizationBasedOnLang('Select plan', 'Dewiswch gynllun'),
  green: false,
  showDetails: true,
  cancelAnytime: false,
};

const BUISNESS_CONF: SubscriptionPlan = {
  id: SUBSCRIPTION_BUSINESS,
  title: getLocalizationBasedOnLang('Business', 'Busnes'),
  priceMonthly: '€99',
  priceAnnual: '€1,100',
  amountOfUsers: getLocalizationBasedOnLang(
    'Up to 99 learners',
    'Hyd at 99 o ddysgwyr',
  ),
  featuresMonthly: [
    getLocalizationBasedOnLang(
      '2,000,000 credits per month',
      `2,000,000 o gredydau'r mis`,
    ),
    getLocalizationBasedOnLang(
      'Supports up to 99 learners',
      'Cefnogaeth i hyd at 99 o ddysgwyr',
    ),
    getLocalizationBasedOnLang(
      'LTI 1.3 interoperability',
      'Rhyngweithrededd LTI 1.3',
    ),
    getLocalizationBasedOnLang('SCORM 1.2 support', 'Allforio SCORM 1.2'),
    getLocalizationBasedOnLang(
      'Free to cancel anytime',
      'Free to cancel anytime',
    ),
  ],
  featuresAnnual: [
    getLocalizationBasedOnLang(
      '24,000,000 AI credits per year',
      `24,000,000 o gredydau y flwyddyn (yn ailosod ar ddechrau pob cylch bilio)`,
    ),
    getLocalizationBasedOnLang(
      'Supports up to 99 learners',
      'Cefnogaeth i hyd at 99 o ddysgwyr',
    ),
    getLocalizationBasedOnLang(
      'LTI 1.3 interoperability',
      'Rhyngweithrededd LTI 1.3',
    ),
    getLocalizationBasedOnLang('SCORM 1.2 support', 'Allforio SCORM 1.2'),
    getLocalizationBasedOnLang(
      'Free to cancel anytime',
      'Free to cancel anytime',
    ),
  ],
  specialText: undefined,
  buttonText: getLocalizationBasedOnLang('Select plan', 'Dewiswch gynllun'),
  green: true,
  showDetails: true,
  cancelAnytime: false,
};

const ENTERPRISE_CONF: SubscriptionPlan = {
  id: SUBSCRIPTION_ENTERPRISE,
  title: getLocalizationBasedOnLang('Enterprise', 'Menter'),
  priceMonthly: getLocalizationBasedOnLang('On request', 'Ar gais'),
  priceAnnual: getLocalizationBasedOnLang('On request', 'Ar gais'),
  amountOfUsers: getLocalizationBasedOnLang(
    'Unlimited learners',
    'Dysgwyr diderfyn',
  ),
  featuresMonthly: [
    getLocalizationBasedOnLang('Unlimited AI credits', 'Unlimited AI credits'),
    getLocalizationBasedOnLang('Unlimited learners', 'Unlimited learners'),
    getLocalizationBasedOnLang('Custom integrations', 'Custom integrations'),
    getLocalizationBasedOnLang(
      'Personalized onboarding & support',
      'Personalized onboarding & support',
    ),
    getLocalizationBasedOnLang(
      'Free to cancel anytime',
      'Free to cancel anytime',
    ),
  ],
  featuresAnnual: [
    getLocalizationBasedOnLang('Unlimited AI credits', 'Unlimited AI credits'),
    getLocalizationBasedOnLang('Unlimited learners', 'Unlimited learners'),
    getLocalizationBasedOnLang('Custom integrations', 'Custom integrations'),
    getLocalizationBasedOnLang(
      'Personalized onboarding & support',
      'Personalized onboarding & support',
    ),
    getLocalizationBasedOnLang(
      'Free to cancel anytime',
      'Free to cancel anytime',
    ),
  ],
  buttonText: getLocalizationBasedOnLang('Get quote', 'Cafwch dyfynbris'),
  green: false,
  showDetails: true,
  cancelAnytime: false,
  specialText: '',
};

export const availableSubscriptionPlans = (currentPlanId: number) => {
  if (
    currentPlanId === SUBSCRIPTION_TRIAL ||
    isCreatorSubscription(currentPlanId)
  ) {
    return [CREATOR_CONF, BUISNESS_CONF, ENTERPRISE_CONF];
  }
  if (isBusinessSubscription(currentPlanId)) {
    return [BUISNESS_CONF, ENTERPRISE_CONF];
  }
  if (currentPlanId > SUBSCRIPTION_ENTERPRISE) {
    return [ENTERPRISE_CONF];
  }
  return [];
};

export const getSubscriptionPlan = (planId: number) => {
  if (planId === SUBSCRIPTION_TRIAL) {
    return null;
  } else if (isCreatorSubscription(planId)) {
    return CREATOR_CONF;
  } else if (isBusinessSubscription(planId)) {
    return BUISNESS_CONF;
  } else {
    return ENTERPRISE_CONF;
  }
};
